export const PROJECT_PORTAL_TITLE = "Gemterra Project Management System";
export const TRADE_PORTAL_TITLE = "Gemterra Trade Drawing System";

export const PROJECT_PORTAL_VERSION = "v2.2";
export const TRADE_PORTAL_VERSION = "v1.3";
export const SITE_APP_VERSION = "v2.3";

export function portalTitle(hostname, pathname) {
  const host = String(hostname || "").toLowerCase();
  const path = String(pathname || "").toLowerCase();
  return host.startsWith("trade.") || path === "/trade" || path.startsWith("/trade/")
    ? TRADE_PORTAL_TITLE
    : PROJECT_PORTAL_TITLE;
}
